import styled from 'styled-components';
import { Form as Unform } from '@unform/web';

export const FormCenter = styled.div`
  display: grid;
  place-items: center;
  height: 100vh;
  width: 100vw;
`;

export const Form = styled(Unform)`
  background: var(--background-color);
  box-shadow: var(--box-shadow);
  border-radius: 10px;
  padding: 25px;
  width: 100%;
  max-width: 500px;
`;

export const Title = styled.h1`
  color: var(--color);
  font-size: 2rem;
  font-family: 'GothamBold';
  text-align: center;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 15px;
`;

export const H1 = styled.h1`
  font-size: 1.5rem;
`;

export const StrongPassword = styled.span`
  width: 100%;
  color: ${({ strength }) => {
    if (strength < 30) return '#f00';
    if (strength >= 30 && strength < 50) return '#FFD700';
    if (strength >= 50) return '#7FFF00';
  }};
`;

export const Description = styled.span`
  color: var(--color);
  font-size: 1.4rem;
  font-family: 'GothamLight', Arial, Helvetica, sans-serif;
`;

export const ButtonContent = styled.div`
  flex-direction: row;
  align-items: center;
  display: flex;
  gap: 10px;
  width: 100%;
  padding-top: 10px;
`;
